import { createContext, useContext, useState } from "react";
import { Toast } from "../components/Toast";
import type { ToastType } from "../types/Toast";
import { useUUID } from "./UUIDContext";

interface ToastContextValue {
    toast: (str: string, type?: ToastType, duration?: number) => void;
}

const toastContext = createContext<ToastContextValue | null>(null);

export function useToast() {
    const ctx = useContext(toastContext);
    if (!ctx) throw new Error("useStore must be used within ToastProvider");
    return ctx;
}

interface ToastData {
    text: string;
    id: string;
    type: ToastType;
    duration: number;
    parseText?: boolean;
}

interface Props {
    duration?: number;
    parseText?: boolean;
    children: React.ReactNode;
}

export function ToastProvider({ duration, parseText, children }: Props) {
    const [queue, setQueue] = useState<ToastData[]>([]);
    const { generateUniqueId } = useUUID();

    return (
        <toastContext.Provider
            value={{
                toast: (str, type?) => {
                    setQueue((prev) => [
                        ...prev,
                        {
                            text: str,
                            id: generateUniqueId(),
                            type: type ?? "info",
                            duration: duration ?? 3000,
                        },
                    ]);
                },
            }}
        >
            {children}
            {/* <Toast text={text} /> */}
            <div className="toast-container">
                {queue.map((t, i) => {
                    if (i >= 3) return null;

                    return (
                        <Toast
                            key={t.id}
                            text={t.text}
                            type={t.type}
                            duration={t.duration}
                            parseText={parseText ?? true}
                            onExpire={() =>
                                setQueue((prev) => [
                                    ...prev.filter((p) => p.id !== t.id),
                                ])
                            }
                        />
                    );
                })}
            </div>
        </toastContext.Provider>
    );
}
